var chunkToChildrenMap = {
	"common_src_components_primitives_richtext_formats_bold_js-common_src_components_primitives_ri-0ce61f": [
		"webpack_container_remote_kfplatform_filePickerV2"
	],
	"src_layouts_index_jsx": [
		"webpack_container_remote_kfplatform_filePickerV2"
	],
	"src_layouts_flowcontainer_index_jsx": [
		"webpack_container_remote_kfplatform_filePickerV2"
	],
	"src_layouts_settingspage_index_jsx": [
		"webpack_container_remote_kfplatform_filePickerV2"
	],
	"src_layouts_flow_nav_index_jsx": [
		"webpack_container_remote_kfplatform_filePickerV2"
	],
	"src_inputs_datetime_index_jsx": [
		"webpack_container_remote_kfplatform_filePickerV2"
	],
	"src_layouts_sharesettings_index_jsx": [
		"webpack_container_remote_kfplatform_filePickerV2"
	],
	"src_inputs_emojipicker_index_jsx-webpack_sharing_consume_default_prop-types_prop-types": [
		"webpack_container_remote_kfplatform_filePickerV2"
	],
	"src_feedback_tour_index_jsx-webpack_sharing_consume_default_react-dom_react-dom-webpack_shari-891889": [
		"webpack_container_remote_kfplatform_filePickerV2"
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };